import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogGeneral } from 'app/dialogs/DialogGeneral';

export interface DialogInfoData {
    title: string;
    message: string;
    okLabel?: string;
}

@Component({
    selector: 'dialog-info',
    templateUrl: 'dialog-info.html',
    styleUrls: ['dialog-info.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogInfo extends DialogGeneral {
    constructor(
        public dialogRef: MatDialogRef<DialogInfo>,
        @Inject(MAT_DIALOG_DATA) public data: DialogInfoData
    ) {
        super(dialogRef);
    }
}
